import { useTranslation } from "react-i18next"
import { X } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"
import { DrawerBody, DrawerHeader } from "@/components/ui/drawer"

type ErrorFallbackProps = { onClose?: () => void; isPreview?: boolean }

const ErrorFallback = (props: ErrorFallbackProps) => {
  const { isPreview, onClose } = props
  const { t } = useTranslation()

  return (
    <>
      <DrawerHeader
        className="animate-fade-in-bottom flex flex-row justify-end gap-4"
        data-testid="appointment-drawer-head">
        {!isPreview && (
          <Button
            data-testid="close-appointment-drawer-icon"
            onClick={onClose}
            variant="circle"
            className="h-10 w-10 shrink-0 p-2">
            <X />
          </Button>
        )}
      </DrawerHeader>
      <DrawerBody>
        <div className="flex flex-1 flex-col items-start justify-center gap-4 text-center text-xl font-bold">
          {t("error.500.description")}
        </div>
      </DrawerBody>
    </>
  )
}

export { ErrorFallback }
